module.exports = __webpack_public_path__ + "static/media/selectDownArrow.e09761e6.svg";